import {IMAGE_SIZES} from './image-sizes.generated';

/**
 * The intrinsic width and height of a screenshot, for the `width`/`height` attributes that let the
 * browser reserve its box before the image loads. Null for anything not in the generated map — an
 * image from outside the folders the generator walks, or one added without rerunning it — so the
 * attributes are simply left off rather than set to a wrong shape.
 */
export function imageWidth(src: string): number | null {
    return sizeOf(src)?.[0] ?? null;
}

export function imageHeight(src: string): number | null {
    return sizeOf(src)?.[1] ?? null;
}

/** Page data spells the same asset both 'assets/x.png' and '/assets/x.png'; the map keys are absolute. */
function sizeOf(src: string): readonly [number, number] | undefined {
    return IMAGE_SIZES[src.startsWith('/') ? src : '/' + src];
}
